export const tradelist_api = {
  url: 'orderLists',
  method: 'post',
  title: '订单列表',
  "query": [],
  "param": {},
  "pagenum": 1,
  "pagesize": 10
}

// 导出
export const list_api = {
  url: 'orderLists',
  method: 'post',
  title: '',
}

// 导出
export const export_api = {
  url: 'orderListsDownload',
  method: 'post',
  title: '导出',
}




// WEBPACK FOOTER //
// ./src/views/base/trade/desc.js